import React from 'react'
import { Redirect } from 'react-router'
import { useCurrentUser } from '../hooks/user'

export function UserRestrictedPage({children}) {
    const user = useCurrentUser()

    if (null === user) {
        return null
    }
    else if (false === user) {
        return <Redirect to='/login'/>
    }
    return (
        <>
            {children}
        </>
    )
}

export function GuestRestrictedPage({children}) {
    const user = useCurrentUser()

    if (null === user) {
        return null
    }
    else if (user) {
        return <Redirect to='/'/>
    }
    return (
        <>
            {children}
        </>
    )
}